/* eslint-disable */
<template>
  <md-modal-dialog
    class="md-dialog"
    @md-opened="event = 'md-opened'"
    :md-click-outside-to-close="false"
    @md-clicked-outside="onModalClose"
  >
    <ModalWrapper>
      <div class="modal" role="dialog" aria-modal="true" aria-live="assertive" aria-labelledby="t-c-title">
        <button class="btn-close" aria-label="Close" @click="onModalClose">
          <IconCross />
        </button>
        <h1 class="t-center">Welcome to the Singapore Trip Planner!</h1>
        <div>
          <h3 class="t-center">
            Plan your vacation to Singapore, powered by Mobi Collaborative AI.
          </h3>
          <h3 class="t-center">
            Simply follow the on screen instructions and receive a personalized itinerary tailored to your preferences.
          </h3>
          <p class="t-center">
            Please be aware that while the Singapore Trip Planner strives to offer tailored suggestions, the final choices remain at your discretion. This website is not owned, supported, endorsed or controlled  in any way by the Singapore Tourism Board or VisitSingapore.com. By accessing and using the website and its services, you unconditionally agree to be bound by these <a href="/file/Terms of Use - Mobi Systems.pdf" target="_blank" rel="noopener noreferrer">Terms of Use</a>.
          </p>
        </div>
      </div>
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
/* eslint-disable */
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';
import IconCross from '@components/svg/cross.vue';

import Vue from 'vue';
export default Vue.component('T-C-Dialog', {
  components: {
    ModalWrapper,
    IconCross,
  },
  methods: {
    onModalClose() {
      this.$modal.submit(null);
    },
  },
});
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(221, 217, 217, 0.87)
  ); */
  --max-dialog-width: 940px;
}

.modal {
  max-height: 50vh;
  overflow: auto;
}

.btn-close {
  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  padding: 20px 20px 11px;
  border-radius: 0 19px 0 20px;
  z-index: 1;
  position: absolute;
  font-size: 14px;
  color: #fff;
  appearance: none;
  border: none;
  cursor: pointer;
}
</style>
<style>
.box-wrapper .box {
  padding: 40px;
}
</style>
